import type { RouteRecordRaw } from 'vue-router'

const homeRoutes: RouteRecordRaw = {
  path: '/',
  name: 'home',
  meta: { layout: 'DashboardLayout', requiresAuth: true, title: 'common.titles.home' },
  component: () => import('@/pages/home/HomePage.vue'),
}

export default homeRoutes
